import { isPlainObject } from 'lodash'

const deepenChildren = (input, prefix='data') =>
  Object.fromEntries(
    Object
      .keys(input)
      .map(key => ({
        key,
        [prefix]: input[key]
      }))
      .map(({ key, data }) => [
        key,
        isPlainObject(data)
          ? ({
            [prefix]: deepenChildren(data, prefix)
          }) : Array.isArray(data)
            ? ({
              [prefix]: data.map(item => deepenChildren(item, prefix))
            })
            : data
      ])
  )

export default deepenChildren
